import { BaseMicrositeData } from '../../../contexts/franchise/microsite-context';

const commercialResidentialText = (data: BaseMicrositeData, focusedType: string): string => {
    const prefixes = {
        Residential: false,
        Commercial: false,
    };

    const prefixKeys = Object.keys(prefixes);

    const relevantServices = (data?.franchise?.servicesProvidedFilterable || []).map(x => x.serviceLine).reduce((acc, val) => [...acc, ...val.split(',')], []);
    const servicesForPage = (data[focusedType]?.linked_service_type?.[0]?.franchise_service_mapping || '').split(',').flatMap((x: string) => {
        if (!prefixKeys.find(y => y.startsWith(x))) {
            return prefixKeys.map(key => `${key} ${x}`);
        }
        return [x];
    });

    const onPageRelevantServicesWithPrefix = relevantServices.filter(x => servicesForPage.includes(x));

    onPageRelevantServicesWithPrefix.forEach((serviceLine) => {
        const foundKey = prefixKeys.find(x => serviceLine.startsWith(x));
        if (foundKey) {
            prefixes[foundKey] = true;
        }
    });

    return Object.entries(prefixes).filter(x => x[1]).map(x => x[0]).join(' & ');
};

export default commercialResidentialText;
